var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    id: "filter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24c-.2 0-.4-.1-.5-.1-.3-.2-.5-.6-.5-.9v-8.7L.2 1.6C0 1.3-.1.9.1.5.3.2.6 0 1 0h22c.4 0 .7.2.9.5.2.3.1.7-.1 1L15 14.3V21c0 .4-.2.7-.6.9l-4 2c-.1.1-.2.1-.4.1zM2.9 2l7.9 11.4c.1.2.2.4.2.6v7.4l2-1V14c0-.2.1-.4.2-.6L21.1 2H2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f5192968710dd10ee2c45dce1399a9c3.svg";
export { ForwardRef as ReactComponent };